import { Durations } from '@/constants/durations'
import { paths } from '@/constants/paths'
import { NextPageWithLayout } from '@/layouts/types'
import { ToastProvider } from '@/molecules/Toast/ToastProvider'
import { Page, PageSeo } from '@/page'
import { getPageByPath } from '@/services/CmsService/Pages'
import { PageDataContext, PageModel, fetchPageDataContext } from '@/services/RenderService'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'

interface ShowsPageProps {
  pageDataContext: PageDataContext
  page: PageModel
  locale: string
}

const ShowsPage: NextPageWithLayout<ShowsPageProps> = ({ page, pageDataContext, locale }) => {
  return (
    <>
      <PageSeo page={page} locale={locale} />
      <div className="bg-core-gray-950 pb-10 pt-28 text-white">
        <main className="flex flex-col gap-8">
          <ToastProvider>
            <Page page={page} pageDataContext={{ ...pageDataContext, contentItemConfig: { padding: true } }} />
          </ToastProvider>
        </main>
      </div>
    </>
  )
}

export const getStaticPaths = getGenericStaticPaths

export const getStaticProps = getStaticPropsErrorHandler<ShowsPageProps>(
  { filePath: 'pages/[locale]/shows/index.tsx' },
  async ({ locale, next404, preview, federationClient }) => {
    // Start independent fetches immediately; fetchPageDataContext depends on page so await it separately
    const pagePromise = getPageByPath(paths.shows.index, { locale, preview })
    const translationsPromise = loadTranslations(locale, ['common', 'account', 'category', 'watch'])
    const page = await pagePromise
    if (!page) return next404(Durations.FIVE_MINUTES_IN_SECONDS)

    const pageDataContext = await fetchPageDataContext(page, preview, locale, federationClient)
    if (!pageDataContext) return next404(Durations.FIVE_MINUTES_IN_SECONDS)

    const translations = await translationsPromise

    return {
      props: {
        pageDataContext,
        page,
        locale,
        ...translations,
      },
      revalidate: Durations.FIFTEEN_MINUTES_IN_SECONDS,
    }
  },
)

export default ShowsPage
